import { type CampaignBanner } from '@hooks-api/types/dataModel/campaigns'
import { Box } from '@pets-ui/Box/Box'
import { Carousel } from '@pets-ui/Carousel/Carousel'
import { Image } from '@pets-ui/Image/Image'
import { Link } from '@pets-ui/Link/Link'
import { Skeleton } from '@pets-ui/Skeleton/Skeleton'
import { useResponsive } from '@pets-ui/useResponsive/useResponsive'
import * as stylex from '@stylexjs/stylex'
import { useMemo } from 'react'

const styles = stylex.create({
  img: {
    aspectRatio: '5 / 2',
    objectFit: 'contain',
    width: '100%',
  },
})
export interface BannerClickParams {
  imageId: number
  position: number
  destinationUrl: string
}

interface CarouselCategoryPromotionProps {
  onCarouselChange?: () => void
  campaignBanners?: CampaignBanner[]
  /** 另開新分頁瀏覽image url  */
  onClickRedirect?: () => void
  onBannerClick?: (params: BannerClickParams) => void
}
export const CarouselCategoryPromotion = (props: CarouselCategoryPromotionProps) => {
  const { campaignBanners, onCarouselChange, onClickRedirect, onBannerClick } = props
  const isMobile = useResponsive('mobile')
  // 因為api直接回傳陣列但目前沒有指定是banner是可以用在哪裡 所以先用find 指定 carousel
  const banners = useMemo(() => campaignBanners?.find(banner => banner.type === 'carousel'), [campaignBanners])

  if (!banners?.images.length) return null
  const images = banners.images
    .filter((image) => {
      if (isMobile && image.device_type === 'pc') return false
      if (!isMobile && image.device_type === 'mobile') return false
      if (!image.url) return false
      return true
    })
    .map(image => ({ ...image, title: banners.title }))

  return (
    <Carousel
      autoplay
      showDots
      autoplayInterval={5000}
      onDotClick={onCarouselChange}
    >
      {images.map((item, index) => {
        const imageElement = (
          <Image
            src={item.url}
            width="100%"
            fallback={<Skeleton width="100%" height="378px" />}
            xStyles={{ imgBase: { img: styles.img } }}
            alt={item.title}
          />
        )
        const handleBannerClick = () => {
          onClickRedirect?.()
          if (item.link_url) {
            onBannerClick?.({
              imageId: item.image_id,
              position: index + 1,
              destinationUrl: item.link_url,
            })
          }
        }
        return (
          <Box key={item.image_id} width="100%">
            {item.link_url
              ? (
                <Link href={item.link_url} target="_blank" rel="noreferrer" onClick={handleBannerClick}>
                  {imageElement}
                </Link>
              )
              : (
                imageElement
              )}
          </Box>
        )
      })}
    </Carousel>
  )
}
